import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs'
import { DashboardStateModel } from './dashboard.model'
import { DashboardService } from '../../dashboard.service'
import {
  DashboardGetSalesTrend,
  DashboardGetCarsAvgTicketTiresTrend,
  DashboardGetBenchmarkSales,
  DashboardGetLabors,
  DashboardGetGrossProfit,
  DashboardGetGoals,
  DashboardGetRanking,
  DashboardGetAll
} from './dashboard.actions'
import { isEmpty } from 'lodash'

@State<DashboardStateModel>({
  name: 'dashboard'
})
@Injectable()
export class DashboardState {
  constructor(private dashboardService: DashboardService) {}

  @Selector()
  static salesTrend(state: DashboardStateModel) {
    return state.salesTrend
  }

  @Selector()
  static carsAvgTicketTiresTrend(state: DashboardStateModel) {
    return state.carsAvgTicketTiresTrend
  }

  @Selector()
  static benchmarkSales(state: DashboardStateModel) {
    return state.benchmarkSales
  }

  @Selector()
  static labors(state: DashboardStateModel) {
    return state.labors
  }

  @Selector()
  static grossProfit(state: DashboardStateModel) {
    return state.grossProfit
  }

  @Selector()
  static goals(state: DashboardStateModel) {
    return state.goals
  }

  @Selector()
  static ranking(state: DashboardStateModel) {
    return state.ranking
  }

  @Action(DashboardGetSalesTrend)
  dashboardGetAverageTrends(ctx: StateContext<DashboardStateModel>) {
    return this.dashboardService.getSalesTrend().pipe(
      tap((res) => {
        ctx.patchState({
          salesTrend: res
        })
      })
    )
  }

  @Action(DashboardGetCarsAvgTicketTiresTrend)
  dashboardGetCarsAvgTicketTiresTrend(ctx: StateContext<DashboardStateModel>) {
    return this.dashboardService.getCarsAvgTicketTiresTrend().pipe(
      tap((res) => {
        ctx.patchState({
          carsAvgTicketTiresTrend: res
        })
      })
    )
  }

  @Action(DashboardGetBenchmarkSales)
  dashboardGetBenchmarkSales(
    ctx: StateContext<DashboardStateModel>,
    { payload }: DashboardGetBenchmarkSales
  ) {
    return this.dashboardService.getBenchmarkSales(payload).pipe(
      tap((res) => {
        ctx.patchState({
          benchmarkSales: res
        })
      })
    )
  }

  @Action(DashboardGetLabors)
  dashboardGetLabors(ctx: StateContext<DashboardStateModel>, { payload }: DashboardGetLabors) {
    return this.dashboardService.getLabors(payload).pipe(
      tap((res) => {
        ctx.patchState({
          labors: res
        })
      })
    )
  }

  @Action(DashboardGetGrossProfit)
  dashboardGetGrossProfit(ctx: StateContext<DashboardStateModel>, { payload }: DashboardGetGrossProfit) {
    return this.dashboardService.getGrossProfit(payload).pipe(
      tap((res) => {
        ctx.patchState({
          grossProfit: res
        })
      })
    )
  }

  @Action(DashboardGetGoals)
  dashboardGetMarketPricing(ctx: StateContext<DashboardStateModel>, { payload }: DashboardGetGoals) {
    return this.dashboardService.getGoals(payload).pipe(
      tap((res) => {
        ctx.patchState({
          goals: res
        })
      })
    )
  }

  @Action(DashboardGetRanking)
  dashboardGetRankingGrossProfitLabor(
    ctx: StateContext<DashboardStateModel>,
    { payload }: DashboardGetRanking
  ) {
    return this.dashboardService.getRanking(payload).pipe(
      tap((res) => {
        ctx.patchState({
          ranking: res
        })
      })
    )
  }

  @Action(DashboardGetAll)
  dashboardGetAll(ctx: StateContext<DashboardStateModel>, { payload }: DashboardGetAll) {
    return this.dashboardService.getAll(payload).pipe(
      tap((res) => {
        ctx.patchState({
          benchmarkSales: res?.sales,
          grossProfit: res?.grossProfit,
          goals: res?.goals,
          labors: res?.labor,
          ranking: res?.leaderboard
        })
      })
    )
  }
}
